export function conditionBranchId(id: string | number, branch: string): string {
  return `${id}-${branch}`
}

// Edge ID builders (stable)
export function normalEdgeId(from: string | number, to: string | number): string {
  return `${from}->${to}`
}

export function conditionSplitEdgeId(condId: string | number, branch: string | 'false'): string {
  return `cond:${condId}:split:${branch}`
}

export function conditionParentEdgeId(parentId: string | number, condId: string | number): string {
  return `cond:${condId}:parent:${parentId}`
}

export function branchTransitionEdgeId(
  condId: string | number,
  branch: 'true' | 'false',
  to: string | number
): string {
  return `cond:${condId}:${branch}->${to}`
}
